"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PagingMetadataFilterKey = void 0;
// Keys for PagingMetadata.FilterKey
var PagingMetadataFilterKey;
(function (PagingMetadataFilterKey) {
    PagingMetadataFilterKey["FAULT_SEVERITY"] = "Fc";
    PagingMetadataFilterKey["IS_RESOLVED"] = "IsResolved";
    PagingMetadataFilterKey["MORE_FILTERS"] = "MoreFilters";
})(PagingMetadataFilterKey = exports.PagingMetadataFilterKey || (exports.PagingMetadataFilterKey = {}));
